@if (showDeleteAllTags) {
  <div class="filter-tag">
    <button
      type="button"
      class="filter-tag-delete-btn"
      aria-label="Delete tag"
      (click)="removeAllTags()"
      (keyup)="removeAllTags()"
      i18n="@@CLEAR_ALL_FILTERS"
    >
      Clear all filters
    </button>
  </div>
}
